import { Directive, HostListener, AfterContentInit } from '@angular/core';

@Directive({
  selector: '[tbl-scroll-x]'
})
export class TblScrollXDirective implements AfterContentInit {

  resizeTimeout:any;
  el:any;
  tblFixed:any;
  tblScrollable:any;

  @HostListener('window:resize', ['$event'])
  onResize(event){
      if (this.resizeTimeout) {
          clearTimeout(this.resizeTimeout);
      }
      this.resizeTimeout = setTimeout((() => {
          this.resizeDone(event);
      }).bind(this), 100);
  }

  calc() {
    const w = (this.el.clientWidth - this.tblFixed.clientWidth) + 'px';
    this.tblScrollable.setAttribute('style', 'width:' + w);
  }


  resizeDone(event):void {
    this.calc();
  }

  ngAfterContentInit() {

    this.el = document.querySelector('.tbl-header');
    this.tblFixed = document.querySelector('.fake-tbl');
    this.tblScrollable = document.querySelector('.table-ctn');

    this.calc();
  }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/tbl-scroll-x.directive.ts